import { Button, theme } from '@hhgtech/hhg-components'
import { DetailStatistic } from 'components/atoms/detailStatistic'
import { Heading, Text } from 'components/atoms/text'
import { TogetherCommunity, TogetherTopic } from 'interfaces/types'
import { useIntl } from 'react-intl'

import { StyledCommunitySection } from '../index.styled'
import { TopicScrollList } from './topicScrollList'
type CommunitySectionProps = {
  community?: TogetherCommunity
  topics?: Array<TogetherTopic>
  title?: string
  message?: string
  openAskDoctor?: (e: boolean) => void
}

export const CommunitySectionMobile = ({
  community,
  topics,
  title,
  message,
  openAskDoctor,
}: CommunitySectionProps) => {
  const { formatMessage: f } = useIntl()

  return (
    <StyledCommunitySection>
      <div className="thumbnail-header">
        <img
          loading="lazy"
          className="thumbnail"
          src={community?.thumbnail}
          alt="thumbnail"
        />
        <a
          href={`/community/${community?.slug}`}
          data-event-category="Together"
          data-event-action="Community Title Click"
          data-event-label={`marrybaby.vn/community/${community?.slug}`}
          className="pointer-event-child-none"
        >
          <Heading type="h4" color={theme.mbColors.dark}>
            {title}
          </Heading>
        </a>
      </div>
      <div className="detail">
        <div className="detail-general">
          <DetailStatistic
            postsCount={community?.postsCount || 0}
            membersCount={community?.membersCount || 0}
          />
        </div>
        {message && (
          <div className="detail-message">
            <Text type="bodytext-3" color={theme.mbColors.gray}>
              {message}
            </Text>
          </div>
        )}
        <div className="detail-tag">
          <TopicScrollList topics={topics} communitySlug={community?.slug} />
        </div>
      </div>
      <div>
        <Button
          theme="marryBaby"
          size="md"
          color="primary"
          className="ask pointer-event-child-none"
          onClick={() => openAskDoctor && openAskDoctor(true)}
          isBlock={true}
          data-event-category="Together"
          data-event-action="Ask Doctor Click"
        >
          {f({
            id: 'mobileBar.askDoctor',
            defaultMessage: 'Ask Doctor',
          })}
        </Button>
      </div>
    </StyledCommunitySection>
  )
}
